import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { startSubscriptionCheckout } from "../lib/publicCheckout";
import { Logo, BRAND_NAME, BRAND_SUBTITLE } from "../components/ui/Logo";
import { Check } from "lucide-react";

const features = [
  "Consulta geriátrica estructurada",
  "Historia clínica del adulto mayor",
  "Seguimiento longitudinal del paciente",
  "Informes médicos profesionales",
  "Registro ilimitado de pacientes",
  "Consultas ilimitadas",
  "Acceso desde cualquier dispositivo",
  "Datos seguros en la nube",
];

const comparison = [
  {
    traditional: "Evaluaciones en papel",
    aurora: "Evaluación geriátrica digital",
  },
  {
    traditional: "Reportes manuales",
    aurora: "Generación automática de informes",
  },
  {
    traditional: "Historia del paciente fragmentada",
    aurora: "Seguimiento longitudinal del paciente",
  },
  {
    traditional: "Consultas largas",
    aurora: "Flujo de trabajo eficiente",
  },
];

export default function Precios() {
  const handleBuyNowPricingCardClick = () => {
    console.log("[checkout-click]", "precios-card-principal");
    startSubscriptionCheckout();
  };

  const handleBuyNowBottomCtaClick = () => {
    console.log("[checkout-click]", "precios-cta-inferior");
    startSubscriptionCheckout();
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-slate-800 font-semibold">
            <Logo variant="icon" size="md" />
            {BRAND_NAME}
          </Link>
          <Link to="/login">
            <Button variant="outline" size="sm" className="border-slate-300">
              Iniciar sesión
            </Button>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Title */}
        <div className="text-center mb-14">
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">
            Precios simples para médicos geriatras
          </h1>
          <p className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto">
            {BRAND_NAME} permite realizar evaluaciones geriátricas completas, seguimiento longitudinal
            del paciente y generación automática de informes médicos profesionales.
          </p>
        </div>

        {/* Pricing Card */}
        <div className="rounded-2xl border-2 border-sky-200 bg-white shadow-lg p-8 sm:p-10 mb-20">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-slate-900">
              Aurora Geriátrica Profesional
            </h2>
            <p className="mt-3 text-4xl font-bold text-slate-900">
              $39 <span className="text-lg font-normal text-slate-500">/ mes</span>
            </p>
            <ul className="mt-8 text-left space-y-3 text-slate-700 max-w-md mx-auto">
              {features.map((f) => (
                <li key={f} className="flex items-center gap-2">
                  <Check className="h-4 w-4 text-sky-600 flex-shrink-0" />
                  {f}
                </li>
              ))}
            </ul>
            <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
              <Button size="lg" className="w-full sm:w-auto min-w-[180px] bg-sky-600 hover:bg-sky-700" onClick={handleBuyNowPricingCardClick}>
                Comprar ahora
              </Button>
              <Link to="/register">
                <Button size="lg" variant="outline" className="w-full sm:w-auto min-w-[180px] border-slate-300">
                  Probar gratis 14 días
                </Button>
              </Link>
            </div>
            <p className="mt-6 text-sm text-slate-500 text-center max-w-md mx-auto">
              Suscripción mensual. Cancelación en cualquier momento.
            </p>
            <p className="mt-2 text-sm text-slate-500 text-center max-w-md mx-auto">
              Pagos procesados de forma segura por Lemon Squeezy.
            </p>
            <p className="mt-2 text-sm text-slate-500 text-center max-w-md mx-auto">
              Acceso inmediato tras la suscripción.
            </p>
          </div>
        </div>

        {/* Comparison */}
        <section className="mb-20">
          <h2 className="text-2xl font-bold text-slate-900 text-center mb-10">
            ¿Por qué usar Aurora Geriátrica?
          </h2>
          <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-slate-200 bg-slate-50">
                  <th className="py-4 px-6 text-left font-semibold text-slate-700">
                    Método tradicional
                  </th>
                  <th className="py-4 px-6 text-left font-semibold text-sky-700">
                    Aurora Geriátrica
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparison.map((row, i) => (
                  <tr
                    key={i}
                    className="border-b border-slate-100 last:border-0 hover:bg-slate-50/50"
                  >
                    <td className="py-4 px-6 text-slate-600">{row.traditional}</td>
                    <td className="py-4 px-6 text-slate-800 font-medium">{row.aurora}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Final CTA */}
        <section className="rounded-2xl bg-sky-600 py-12 px-8 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-white">
            Comienza tu prueba gratuita de 14 días
          </h2>
          <p className="mt-3 text-sky-100">
            Sin tarjeta de crédito. Acceso completo a todas las funciones.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-4">
            <Link to="/register">
              <Button size="lg" className="bg-white text-sky-600 hover:bg-sky-50">
                Probar gratis 14 días
              </Button>
            </Link>
            <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10" onClick={handleBuyNowBottomCtaClick}>
              Comprar ahora
            </Button>
            <Link to="/register">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10">
                Crear cuenta
              </Button>
            </Link>
          </div>
        </section>

        <footer className="mt-16 py-8 border-t border-slate-200">
          <div className="flex flex-wrap justify-center gap-6 text-slate-500 text-sm mb-4">
            <Link to="/precios" className="hover:text-sky-600">Precios</Link>
            <Link to="/marketing" className="hover:text-sky-600">Marketing</Link>
            <Link to="/contacto" className="hover:text-sky-600">Contacto</Link>
            <Link to="/privacidad" className="hover:text-sky-600">Privacidad</Link>
            <Link to="/terminos" className="hover:text-sky-600">Términos</Link>
            <Link to="/login" className="hover:text-sky-600">Iniciar sesión</Link>
          </div>
          <p className="text-center text-slate-500 text-sm">{BRAND_NAME} · {BRAND_SUBTITLE}</p>
        </footer>
      </main>
    </div>
  );
}
